var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccDairy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Diary_stores",
    "data-name": "Diary stores",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8393",
    "data-name": "Rectangle 8393",
    width: 28,
    height: 28,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35892",
    "data-name": "Path 35892",
    d: "M8.264,5.619l-1.8,2.652H21.091L19.21,5.619Z",
    fill: "#b3b5c4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35250",
    "data-name": "Group 35250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35249",
    "data-name": "Group 35249",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35893",
    "data-name": "Path 35893",
    d: "M19.052,3.994H8.276V2.626a.766.766,0,0,1,.764-.77h9.326a.754.754,0,0,1,.77.684V3.994Z",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35894",
    "data-name": "Path 35894",
    d: "M6.425,26.144H21.048V9.9H6.425Zm11.8-8.123H9.333v-5.9h8.894Z",
    fill: "#b3b5c4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccDairy);
export default __webpack_public_path__ + "static/media/mcc_dairy.09f67edb4ea2b71d35290feb0bd3f504.svg";
export { ForwardRef as ReactComponent };